<ion-header class="ion-no-border">
    <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker 
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-notificationsettings">
    </smr-stylist-picker> 
  </ion-toolbar>
</ion-header>

<ion-content>

  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>  

  <salonmonster-tap-retry 
    *ngIf="errorOccurredWhileLoadingStylistPicker" 
    (click)="onTapToReload()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker">

    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
        <form [formGroup]='notificationSettingsForm'>
          <h2 padding-left>Notifications</h2>
          <ion-item class="padding">
            <p><b>salonMonster can send "push notifications" to your phone when there is new activity on your account.</b> You can configure what notifications you'd like to receive here.</p>
          </ion-item>
          <ion-item>
            <ion-label stacked>Send notificaitons to me for</ion-label>
            <ion-select formControlName="notifyForAllStaffActivity">
              <ion-select-option *ngFor="let option of notifyForAllStaffActivitySelectOptions" [value]="option.value">
                {{ option.label }}
              </ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-label>A new booking is made</ion-label>
            <ion-toggle formControlName="newBookingNotification"></ion-toggle>
          </ion-item>

          <ion-item>
            <ion-label>A booking is edited</ion-label>
            <ion-toggle formControlName="editBookingNotification"></ion-toggle>
          </ion-item>

          <ion-item>
            <ion-label>A booking is cancelled</ion-label>
            <ion-toggle formControlName="deleteBookingNotification"></ion-toggle>
          </ion-item>

          <ion-item>
            <ion-label>A new wait list request is made</ion-label>
            <ion-toggle formControlName="waitListRequestNotification"></ion-toggle>
          </ion-item>

          <br/>
          <ion-button 
            expand="block"
            class="hidden-sm-down" 
            (click)="onNotificationSettingsFormSave()">
            Save
          </ion-button>
        </form>
      </ion-col>

      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>

<ion-footer 
  class="ion-no-margin hidden-md-up" 
  *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker">
  <ion-toolbar class="ion-no-margin ion-no-padding">
      <ion-button 
        [disabled]="isLoading" 
        
        fill="solid"
        color="primary"
        expand="block"
        (click)="onNotificationSettingsFormSave()">
        Save
      </ion-button> 
  </ion-toolbar>
</ion-footer>